(function () {
  // ─── Scroll-text animation (existing) ────────────────────────────────────────

  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");
    if (!text || typeof ScrollTrigger === "undefined") return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  // ─── Highlight-image parallax ────────────────────────────────────────────────

  var START_Y = -100;   // image starts 100px above its natural position
  var OVERSHOOT = 100;  // image ends 100px past the section bottom

  var rafRegistry = new Map();

  var initHighlightParallax = function (section) {
    if (rafRegistry.has(section)) {
      cancelAnimationFrame(rafRegistry.get(section));
      rafRegistry.delete(section);
    }

    var banner  = section.querySelector(".media-banner");
    var wrapper = section.querySelector(".media-banner__wrapper");
    var el      = section.querySelector(".media-banner__highlight-image");

    if (!banner || !wrapper || !el) return;
    if (!el.hasAttribute("data-highlight-animate")) return;

    var lastY = null;

    var tick = function () {
      var wrapperRect = wrapper.getBoundingClientRect();
      var vh          = window.innerHeight || document.documentElement.clientHeight;
      var imgH        = el.offsetHeight || 1;
      var wrapperH    = wrapper.offsetHeight;

      // 0 = wrapper top just appeared at viewport bottom
      // 1 = wrapper bottom just left at viewport top
      var totalTravel = vh + wrapperRect.height;
      var progress    = (vh - wrapperRect.top) / totalTravel;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      // Where the image bottom should end up past the wrapper bottom
      var endY = wrapperH - imgH + OVERSHOOT;

      var y = START_Y + progress * (endY - START_Y);

      if (y !== lastY) {
        el.style.transform = "translateY(" + y + "px)";
        lastY = y;
      }

      rafRegistry.set(section, requestAnimationFrame(tick));
    };

    rafRegistry.set(section, requestAnimationFrame(tick));
  };

  var destroyHighlightParallax = function (section) {
    if (!rafRegistry.has(section)) return;
    cancelAnimationFrame(rafRegistry.get(section));
    rafRegistry.delete(section);
  };

  // ─── Init / lifecycle ────────────────────────────────────────────────────────

  var initHighlightFadeIn = function (section) {
    var el = section.querySelector(".media-banner__highlight-image");
    if (!el) return;

    var img = el.querySelector("img");
    var reveal = function () {
      el.classList.add("animated");
    };

    if (img && img.complete) {
      reveal();
    } else if (img) {
      img.addEventListener("load", reveal, { once: true });
    } else {
      reveal();
    }
  };

  var initSection = function (section) {
    if (!section || !section.classList.contains("media-banner-section")) return;
    initAnimation(section);
    initHighlightParallax(section);
    initHighlightFadeIn(section);
  };

  var run = function () {
    document.querySelectorAll(".media-banner-section").forEach(initSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var s = e.target.classList.contains("media-banner-section")
      ? e.target
      : e.target.querySelector(".media-banner-section");
    if (s) initSection(s);
  });

  document.addEventListener("shopify:section:unload", function (e) {
    var s = e.target.classList.contains("media-banner-section")
      ? e.target
      : e.target.querySelector(".media-banner-section");
    if (s) destroyHighlightParallax(s);
  });
})();
